<template>
  <!--<li><router-link to="/" class="header-link">Home</router-link></li>-->
  <footer id="FooterWrap">
  	<div class="ContentAligher">
  		<div class="row">
  			<div class="col-md-4">
  				<h6>Talk to us</h6>
  				<p>Need support? In our commitment to excellence and safety, we remain ready to support to you from the start of your project, right up to its completion. </p>
  			</div>
  			<div class="col-md-2">
  				<ul>
					    <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about-us">About Us </router-link></li>
              <li><router-link to="/services">Services </router-link></li>
              <li><router-link to="/finishes" >Finishes </router-link></li>
              <li><router-link to="/our-clients" >Clients </router-link></li>
              
				</ul>
  			</div>
  			<div class="col-md-2">
  				<ul>
              <li><router-link to="/portfolio">Portfolio </router-link></li>
              <li><router-link to="/catalog">Catalog </router-link></li>
              <li><router-link to="/cab-builder">CAB Builder </router-link></li>
              <li><router-link to="/contact-us">Contact Us </router-link></li>
				</ul>
  			</div>
  			<div class="col-md-4">
  				<hr>
  				Copyright &copy; 2020 USC Elevator Interiors<br/>
				  All Rights Reserved
  			</div>
  		</div>
  	</div>
  </footer>
</template>
<script>
export default{
  name: 'Footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue